import vconst from 'utils/helpers/structs/vconst';

export interface PendingWarehouseInfo {
    team?: { ID?: number } | null;
    object?: { ID?: number } | null;
    custom?: { ID?: number } | null;
    customId?: number | null;
    reservObjectId?: number | null;
}

export interface PendingConfirmUser {
    admin?: number | boolean;
    access?: {
        role?: string;
        team?: number | string;
        warehouseOps?: boolean;
    } | null;
}

export const canConfirmPendingIncome = (
    user: PendingConfirmUser | null | undefined,
    wId: number,
    warehouse?: PendingWarehouseInfo | null,
): boolean => {
    if (!user || !warehouse) return false;
    const teamId = Number(warehouse.team?.ID || 0);
    const isReserve = Number(warehouse.reservObjectId || 0) > 0;
    const isCustom = Number(warehouse.customId || warehouse.custom?.ID || 0) > 0;
    const isObject = Number(warehouse.object?.ID || 0) > 0 && !isReserve;
    const isTeam = teamId > 0 && !isReserve && !isCustom && !isObject;
    if (isTeam) {
        return user.access?.role === 'executor' && Number(user.access?.team || 0) === teamId;
    }
    const isMain = Number(wId) === vconst.waherouseMainId;
    if (!(isMain || isReserve || isCustom)) return false;
    if (user.admin) return true;
    return user.access?.role === 'manager' && !!user.access?.warehouseOps;
};
